import { render, staticRenderFns } from "./ColorPlaten.vue?vue&type=template&id=be131cb6&scoped=true&"
import script from "./ColorPlaten.vue?vue&type=script&lang=js&"
export * from "./ColorPlaten.vue?vue&type=script&lang=js&"
import style0 from "./ColorPlaten.vue?vue&type=style&index=0&id=be131cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be131cb6",
  null
  
)

export default component.exports